export class ThrottledAnimation {

  private fpsInterval: number = 1000 / 60;
  private lastFrameTimestamp = window.performance.now();
  private stopped: boolean = true;
  private skipFrame: boolean = false;

  constructor() { }

  public start(): void {
    this.stopped = false;
    this.skipFrame = false;
  }

  public stop(): void {
    this.stopped = true;
  }

  public nextFrame(callback: () => void): void {
    if (this.stopped && this.skipFrame) return;

    this.skipFrame = true;
    const now = window.performance.now();
    const elapsed = now - this.lastFrameTimestamp;
    
    if(elapsed < this.fpsInterval) return;

    this.lastFrameTimestamp = now;
    this.skipFrame = false;
    callback();

    requestAnimationFrame(() => {
      this.nextFrame(callback);
    });
  }

  get playing(): boolean {
    return !this.stopped;
  }

}